import React from 'react';
import { Column } from 'primereact/column';

const OdcTableContent = ({ status, actionTemplate, formatters }) => {
    const { formatDate, formatAmount, formatValue } = formatters;

    const statusBody = (r) => {
        const s = r.status?.toLowerCase();
        let bgColor = '#94a3b8'; // Default Gray
        let textColor = '#ffffff';

        if (s === 'dispatched' || s === 'dispatchedonly') {
            bgColor = '#fde047'; // Yellow
            textColor = '#854d0e';
        } else if (s === 'setteled') {
            bgColor = '#22c55e'; // Green
            textColor = '#ffffff';
        } else if (s === 'pending') {
            bgColor = '#f97316'; // Orange
        } else if (s === 'cancelled') {
            bgColor = '#ef4444'; // Red
        }

        return (
            <span
                style={{
                    backgroundColor: bgColor,
                    color: textColor,
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '11px',
                    fontWeight: '700',
                    textTransform: 'uppercase',
                    display: 'inline-block',
                    width: '90px',
                    textAlign: 'center'
                }}
            >
                {r.status}
            </span>
        );
    };

    const amountCol = <Column key="amt" field="total_paid_amount" header="Amount" textAlign="right" body={(r) => formatAmount(r.total_paid_amount)} />;

    if (status === 'pending' || status === 'cancelled') {
        return [
            <Column key="no" field="bill_no" header="Order No" body={(r) => formatValue(r.bill_no)} />,
            <Column
                key="dt"
                header="Order Date"
                body={(r) => (
                    <div>
                        {formatDate(r.bill_date)}
                        <br />
                        <small>{r.bill_time}</small>
                    </div>
                )}
            />,
            <Column key="name" field="customer_name" header="Customer" />,
            amountCol,
            <Column key="paytype" header="Pay Mode" body={(r) => formatValue(r.payment_type || r.final_mop)} />,
            <Column key="stat" header="Status" body={statusBody} />,
            <Column key="act" header="Actions" body={actionTemplate} />
        ];
    }

    return [
        <Column key="in" field="in_no" header="Invoice No" />,
        <Column key="idt" header="Invoice Date" body={(r) => <div>{formatDate(r.invoice_date)}</div>} />,
        <Column key="comp" field="company_name" header="Company" />,
        amountCol,
        <Column key="paytype" header="Pay Mode" body={(r) => formatValue(r.payment_type || r.final_mop)} />,
        status === 'setteled' && <Column key="stlmnt" header="Settled Date" body={(r) => formatDate(r.stlmnt_date)} />,
        <Column key="stat" header="Status" body={statusBody} />,
        <Column key="act" header="Actions" body={actionTemplate} />
    ].filter(Boolean);
};

export default OdcTableContent;
